import {loadStripe} from "@stripe/stripe-js";

let stripePromise = null;

export const getStripe = async () => {
  if (!stripePromise) {
    const publishableKey = import.meta.env.VITE_PUBLISHABLE_KEY
    stripePromise = loadStripe(publishableKey);
    console.log('Stripe is initialized');
  }
  return stripePromise;
};
